module.exports = __webpack_public_path__ + "static/media/university-house-r.c7ecd143.png";